import React from 'react';
import { Trans } from '@lingui/react';

export default {
  banner: <Trans id="bike.quote.variant.banner" />,
  discountCaption: <Trans id="bike.quote.bike.discountCaption" />,
  getPrice: <Trans id="bike.quote.getPrice" />,
  originalValue: <Trans id="bike.quote.bike.originalValue" />,
  title: <Trans id="bike.quote.title" />,
  type: <Trans id="bike.quote.bike.type" />,
};
